import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WeekDayTimeAvailability from './week-day-time-availability';
import WeekDayTimeAvailabilityDetail from './week-day-time-availability-detail';
import WeekDayTimeAvailabilityUpdate from './week-day-time-availability-update';
import WeekDayTimeAvailabilityDeleteDialog from './week-day-time-availability-delete-dialog';

const WeekDayTimeAvailabilityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WeekDayTimeAvailability />} />
    <Route path="new" element={<WeekDayTimeAvailabilityUpdate />} />
    <Route path=":id">
      <Route index element={<WeekDayTimeAvailabilityDetail />} />
      <Route path="edit" element={<WeekDayTimeAvailabilityUpdate />} />
      <Route path="delete" element={<WeekDayTimeAvailabilityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WeekDayTimeAvailabilityRoutes;
